<mat-card style="position: fixed; width: 100%; z-index: 10;">
    <button id="toggle-button-header" mat-icon-button (click)="goBack()">
        <mat-icon class="mat-icon-menu">arrow_back</mat-icon>
      </button>
      
    <span  class="pointer logo-header" routerLink="/">
    <img id="logo" src="/assets/images/logo.png" alt="" srcset="">
  </span></mat-card>